module.exports = __webpack_public_path__ + "static/media/person-sign.8ae46126.svg";